import { BaseModel } from '@tcc-mono/shared/data-access';
import { Animal } from './animal.model';

export class SlaughterList extends BaseModel {
  id: number;
  name: string;
  ubn: string;
  date: string;
  number: string;
  created_at: string;
  updated_at: string;
  animal_count: number;
  avg_color: number;
  avg_fat: number;
  avg_kind: number;
  avg_weight: number;
  lines?: SlaughterListLine[];
}

export interface SlaughterListLine {
  id: number
  slaughter_list_id: number
  country_code: string
  identification_number: string
  weight: string
  kind: number
  color: number
  fat: number
  slaughter_date: string
}
